import { usePlanningBacklogQuery } from './useBacklog';

export const usePlanningBacklogChooser = () => {
  const timelineData = usePlanningBacklogQuery();

  return timelineData;
};
